import React from 'react'

import { map, lowerCase, flatMap, filter, isEmpty } from 'lodash'
import { Accordion } from 'camino-react'

import AssetsTable from './Coverage/AssetsTable'

const filteredCalligoDeviceTypes = ({ calligoDeviceTypes, assetRuleTypes }) => {
  const assets = flatMap(assetRuleTypes, ruleType => ruleType.assets)

  return filter(calligoDeviceTypes, deviceType => !isEmpty(filter(assets,
    ({ calligo_device_type: calligoDeviceType }) => lowerCase(calligoDeviceType) === lowerCase(deviceType.label))))
}

const OnPremIT = ({
  calligoDeviceTypes,
  assetRuleTypes
}) => (
  <Accordion>
    {map(filteredCalligoDeviceTypes(({ calligoDeviceTypes, assetRuleTypes })), category => ({ title: category.label,
      content: (
        <Accordion>
          {map(assetRuleTypes, assetRuleType => ({
            title: assetRuleType.label,
            content: <AssetsTable {...{ assetRuleType, category }} />
          }))}
        </Accordion>
      ) }))}
  </Accordion>
)

export default OnPremIT
